<template>
    <div class="outsourcing-batch-import-dialog-upload-file-view">
        <div>
            <el-button type="primary" class="upload-file-btn" @click="onUploadSheet">上傳 Excel 檔案</el-button>
        </div>
        <div>
            <el-button @click="onDownloadExample">下載 Excel 匯入範本</el-button>
            <el-button @click="$emit('close')">取消</el-button>
        </div>

        <a v-show="false" ref="ExampleLink" :href="`/download/${downloadFileName}v${downloadFileVersion}.xlsx`" download style="margin-left: 10px;">下載範本</a>
        <input v-show="false" ref="fileInput" type="file" accept=".csv,.xlsx" @change="onFileInputChange" />
    </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
    data() {
        return {
            downloadFileVersion: 2,
        };
    },
    computed: {
        downloadFileName() {
            return '客戶匯入範例';
        },
    },
    methods: {
        onUploadSheet() {
            this.$refs.fileInput.click();
        },
        onDownloadExample() {
            this.$refs.ExampleLink.click();
        },
        onFileInputChange(event) {
            if (!event.target.files[0]) return;

            const inputFile = event.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const wb = XLSX.read(e.target.result, { type: 'binary' });

                    // eslint-disable-next-line no-throw-literal
                    if (!wb.Sheets.import) throw { msg: '無效的檔案，請檢查後重新上傳' };

                    this.$emit('updateSheet', XLSX.utils.sheet_to_json(wb.Sheets.import));
                    this.$emit('updateFileName', event.target.files[0].name);
                } catch (err) {
                    this.$message({
                        showClose: true,
                        message: err.msg,
                        type: 'error',
                    });
                }
            };

            reader.readAsArrayBuffer(inputFile);
        },
    },
};
</script>

<style lang="scss" scoped>
.outsourcing-batch-import-dialog-upload-file-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
        width: 260px;
        display: flex;
        justify-content: space-between;
        &:first-child {
            margin-bottom: 20px;
        }
    }
    .upload-file-btn {
        width: 100%;
    }
}
</style>
